import api from "../api/api";

export const getPermissionsByRoleId = async (roleId) => {
  const res = await api.get(`/permissions/${roleId}`); // <-- pakai "permissions"
  return res.data.data.permissions;
};

export const updatePermissionsByRoleId = async (roleId, permissionsObject) => {
  const permissions = [];

  Object.entries(permissionsObject).forEach(([moduleName, actions]) => {
    Object.entries(actions).forEach(([action, isChecked]) => {
      if (isChecked && action !== "semua") {
        permissions.push({ module: moduleName, action });
      }
    });
  });

  console.log("permissionsObject:", permissionsObject);
  console.log("Sending to API:", JSON.stringify({ permissions }, null, 2));

  const res = await api.put(`/permissions/${roleId}`, { permissions });
  return res.data;
};
